export const chainId = parseInt(process.env.REACT_APP_CHAIN_ID || '1', 10);
